import { Nav, NavUl } from '../components';
import { NavList } from './nav-desktop-list';

import type { NavMainItem } from './nav-desktop-list';

// ----------------------------------------------------------------------

type NavDesktopProps = React.ComponentProps<typeof Nav> & {
  data: NavMainItem[];
  onDemoExploreClick?: () => void;
};

export function NavDesktop({ data, sx, onDemoExploreClick, ...other }: NavDesktopProps) {
  return (
    <Nav
      sx={[
        () => ({
          /* Put styles */
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      <NavUl
        sx={{
          gap: 5,
          height: 1,
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        {data.map((list) => (
          <NavList key={list.title} data={list} onDemoExploreClick={onDemoExploreClick} />
        ))}
      </NavUl>
    </Nav>
  );
}
